import { useState, useEffect } from 'react'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'

const AnalysisItemNavigator = ({ items = [], visible, setVisible }) => {
    const total = items.length

    if (total <= 1) return null

    const goNext = () => setVisible(v => (v < total - 1 ? v + 1 : 0))
    const goPrev = () => setVisible(v => (v > 0 ? v - 1 : total - 1))

    return (
        <div className="analysis-navigator">
            <button
                className="analysis-navigator-btn"
                onClick={goPrev}
                aria-label="Vorige"
            >
                <ChevronLeftIcon />
            </button>
            <span className="analysis-navigator-counter">
                {visible + 1} / {total}
            </span>
            <button
                className="analysis-navigator-btn"
                onClick={goNext}
                aria-label="Volgende"
            >
                <ChevronRightIcon />
            </button>
        </div>
    )
}

export default AnalysisItemNavigator
